import React, { useState, useEffect } from 'react';

const Hero = ({ onLoaded }) => {
  const [heroReady, setHeroReady] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    // Add a minimum loader time so you can see it
    setTimeout(() => {
      // Preload the hero image with high priority
      const preloadImage = new Image();
      preloadImage.src = '/profile.png';

      preloadImage.onload = () => {
        setImageLoaded(true);
        setHeroReady(true);
        onLoaded && onLoaded();
      };

      preloadImage.onerror = () => {
        setImageError(true);
        setHeroReady(true);
        onLoaded && onLoaded();
      };

      // Fallback timeout in case image takes too long
      const fallbackTimer = setTimeout(() => {
        if (!imageLoaded && !imageError) {
          setHeroReady(true);
          onLoaded && onLoaded();
        }
      }, 1500); // 1.5 second fallback

      return () => clearTimeout(fallbackTimer);
    }, 1000); // Show loader for at least 1 second
  }, [onLoaded, imageLoaded, imageError]);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <section className={`hero ${heroReady ? 'hero-loaded' : ''}`}>
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-image">
            <div className="image-wrapper">
              {!imageLoaded && !imageError && (
                <div className="image-placeholder">
                  <div className="loading-spinner"></div>
                </div>
              )}
              <img
                src="/profile.png"
                alt="Digital Excellence Team"
                className={`character-image ${imageLoaded ? 'loaded' : ''} ${imageError ? 'error' : ''}`}
                onLoad={handleImageLoad}
                onError={handleImageError}
                loading="eager"
                fetchpriority="high"
                style={{
                  opacity: imageLoaded ? 1 : 0,
                  transition: 'opacity 0.3s ease-in-out'
                }}
              />
            </div>
          </div>

          <h1 className="hero-title">
            Building Digital Excellence
          </h1>

          <p className="hero-description">
            We craft exceptional digital experiences through innovative design and cutting-edge technology.
          </p>

          <div className="hero-actions">
            <a href="#contact" className="btn btn-primary btn-hero">
              <span>Start Project</span>
              <i className="fas fa-arrow-right"></i>
            </a>
            <a href="#work" className="btn btn-secondary btn-hero">
              <span>Our Work</span>
              <i className="fas fa-eye"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 